import { Component, OnInit } from '@angular/core';
import {   SeedDataService} from '../../Services/index';
import { DataTable, SelectItem, DropdownModule, DataTableModule, ButtonModule, DialogModule, InputTextModule, MessagesModule, GrowlModule, Message, ConfirmationService, MultiSelectModule, BlockUIModule, SharedModule, Dropdown, InputText} from 'primeng/primeng';
@Component({
  selector: 'app-prior-relevant-experience',
  templateUrl: './prior-relevant-experience.component.html',
  styleUrls: ['./prior-relevant-experience.component.css']
})
export class PriorRelevantExperienceComponent implements OnInit {
  details: any[] = [];
  msgs: Message[] = [];
  constructor(private seedDataService: SeedDataService) { }

  ngOnInit() {
    this.bindDetailsList();
  }

  bindDetailsList()
  {
    debugger;
    this.seedDataService.GetMissingPriorRelevantExperience().subscribe((data) => {
      this.details = data;
      
  });
  }
  onRowEdit(Profile) {
    Profile.isEditing = true;
}
onRowSave(Profile) {
  debugger;
  Profile.isEditing = false;
  this.seedDataService.UpdatePriorRelevantExperience(Profile).subscribe((data) => {
    this.details = Array.isArray(data) ? data : []; // Ensure it's an array
    this.msgs = [];
            debugger
            if(data && data.errorMessage)
            {
                this.msgs.push({ severity: 'error', summary: '', detail: data.errorMessage});
            }
            else{
    console.log(data);
    this.msgs.push({ severity: 'success', summary: '', detail: 'Record updated successfully.' });
    this.bindDetailsList();
            }
});


}
}



// WEBPACK FOOTER //
// ./src/app/Components/prior-relevant-experience/prior-relevant-experience.component.ts